// Cards (documento de design): a carta da criatura é liberada na etapa 2 do bestiário (2.500 abates);
// as cartas equipadas dão bônus à build. Raridades, slots e efeitos abaixo são proposta (o design deixou em aberto).
import type { AffixKey } from './affixes.js';
import type { BestiaryInfo } from './charms.js';

export type CardRarity = 0 | 1 | 2 | 3;
export const CARD_RARITY_NAMES = ['Comum', 'Rara', 'Épica', 'Lendária'] as const;
/** raridade pela dificuldade da criatura no bestiário (estrelas do Tibia) */
export const cardRarity = (info: BestiaryInfo | undefined): CardRarity => {
  const s = info?.stars ?? 1;
  return s >= 5 ? 3 : s === 4 ? 2 : s === 3 ? 1 : 0;
};
/** valor do bônus (%) por raridade */
export const CARD_VALUE = [0.5, 1, 1.5, 2] as const;

/** bônus de cada classe do bestiário */
export const CARD_CLASS_STAT: Record<string, AffixKey> = {
  Demon: 'res_fire', Undead: 'res_death', Aquatic: 'res_ice', Amphibic: 'res_ice', Elemental: 'res_energy', Plant: 'res_earth',
  Reptile: 'res_earth', Slime: 'res_earth', Fey: 'res_holy', Construct: 'res_physical', Dragon: 'dmg', Giant: 'hp', Vermin: 'hp',
  Human: 'crit', Humanoid: 'critdmg', Lycanthrope: 'lifeleech', Magical: 'mana', Inkborn: 'mana', 'Extra Dimensional': 'manaleech',
  Mammal: 'speed', Bird: 'speed',
};
export const cardStat = (info: BestiaryInfo | undefined): AffixKey => CARD_CLASS_STAT[info?.class ?? ''] ?? 'dmg';

/** Espaços de carta: 3, mais 1 no level 200 e mais 1 no level 500. */
export const cardSlots = (level: number) => 3 + (level >= 200 ? 1 : 0) + (level >= 500 ? 1 : 0);
